import { render, staticRenderFns } from "./FormControlSecondaryTooltip.vue?vue&type=template&id=74b2b212"
import script from "./FormControlSecondaryTooltip.vue?vue&type=script&lang=js"
export * from "./FormControlSecondaryTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports